import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://bum-desa-warga-dekat-bandung-production.up.railway.app";

export default function AdminLogin() {
  const navigate = useNavigate();

  const [checkingAuth, setCheckingAuth] = useState(true);
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token =
      localStorage.getItem("token") || localStorage.getItem("adminToken");

    if (token && token !== "undefined" && token !== "null") {
      navigate("/admin/posts", { replace: true });
      return;
    }

    setCheckingAuth(false);
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (loading) return;

    setLoading(true);
    setError("");
    setMessage("");

    localStorage.removeItem("token");
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminData");

    try {
      const res = await fetch(`${API_BASE_URL}/api/admin/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: form.email,
          password: form.password,
        }),
      });

      const data = await res.json();
      console.log("LOGIN RESPONSE:", data);

      if (!res.ok) {
        throw new Error(data.message || "Login gagal");
      }

      const token = data.token || data.access_token || data?.data?.token;
      const adminData = data.admin || data.user || data?.data?.admin || {};

      if (!token || token === "undefined" || token === "null") {
        throw new Error("Login berhasil tapi token tidak dikirim dari backend");
      }

      localStorage.setItem("token", token);
      localStorage.setItem("adminToken", token);
      localStorage.setItem("adminData", JSON.stringify(adminData));

      const savedToken =
        localStorage.getItem("token") || localStorage.getItem("adminToken");

      if (!savedToken) {
        throw new Error("Token gagal tersimpan di browser");
      }

      setMessage("Login berhasil, mengalihkan...");

      setTimeout(() => {
        navigate("/admin/posts", { replace: true });
      }, 300);
    } catch (err) {
      console.error("LOGIN ERROR:", err);
      setError(err.message || "Terjadi kesalahan saat login");
      localStorage.removeItem("token");
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminData");
    } finally {
      setLoading(false);
    }
  };

  if (checkingAuth) {
    return (
      <div className="min-h-screen bg-[#f8faf8] font-serif">
        <Navbar />
        <WhatsAppButton />

        <section className="pt-32 pb-20 px-6">
          <div className="max-w-xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-8 text-center text-gray-500">
            Memeriksa sesi login admin...
          </div>
        </section>

        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#f8faf8] font-serif">
      <Navbar />
      <WhatsAppButton />

      <section className="pt-32 pb-20 px-6">
        <div className="max-w-xl mx-auto bg-white rounded-2xl border border-gray-200 shadow-sm p-8">
          <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-3">
            Admin Access
          </p>

          <h1 className="text-4xl text-[#3d4f45] font-light mb-3">
            Login Admin
          </h1>

          <p className="text-sm text-gray-500 mb-8">
            Masuk untuk mengelola berita, produk, dan konten website.
          </p>

          {message && (
            <div className="mb-4 rounded-xl bg-green-50 border border-green-200 px-4 py-3 text-sm text-green-700">
              {message}
            </div>
          )}

          {error && (
            <div className="mb-4 rounded-xl bg-red-50 border border-red-200 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm text-[#3d4f45] mb-2">Email</label>
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="admin@gmail.com"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#3d4f45]"
                required
              />
            </div>

            <div>
              <label className="block text-sm text-[#3d4f45] mb-2">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                placeholder="Masukkan password admin"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#3d4f45]"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#3d4f45] text-white py-3 rounded-xl text-sm hover:bg-[#4d6156] transition disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Memproses..." : "Login"}
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}
